<template>
    <div>
        <hts-loading :loading="loading">
            <div class="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-x-2 gap-y-8">
                <hts-analytics-card-chart
                    v-if="!loading"
                    class="min-h-[365px]"
                    title="Đơn hàng chưa hoàn tất phân bổ"
                    :labels="dataAnalytics.ordersPendingAllocation.labels"
                    :series="[{ name: 'Đơn hàng chưa hoàn tất phân bổ', data: dataAnalytics.ordersPendingAllocation.series }]" />
                <hts-analytics-card-chart
                    v-if="!loading"
                    class="min-h-[365px]"
                    title="Số chặng hàng chưa có xe"
                    :labels="dataAnalytics.pendingAllocationJourneys.labels"
                    :series="[{ name: 'Số chặng hàng chưa có xe', data: dataAnalytics.pendingAllocationJourneys.series }]" />
            </div>
        </hts-loading>
    </div>
</template>
<script lang="ts" setup>
import { $api, $lodash } from '#imports'
const loading = ref(false)
const dataAnalytics = ref<{
  ordersPendingAllocation: { labels: Array<{ [key: string]: any }>; series: Array<any> }
  pendingAllocationJourneys: { labels: Array<{ [key: string]: any }>; series: Array<any> }
}>({
  ordersPendingAllocation: { labels: [], series: [] },
  pendingAllocationJourneys: { labels: [], series: [] }
})

onMounted(async () => {
  loading.value = true
  const api = $url.dashboard.directionOfFleet.getOrderAllocationaVolume
  const data: any = await $api(api)
  const resData: any = $lodash.get(data, 'data.value')
  if (resData?.success) {
    dataAnalytics.value = resData.data
  }
  loading.value = false
})
</script>
